import axios from 'axios';
import request from '@/services/index';
const uploadToOSS = async (signatureParameters, file, onProgress, onCancel, hideErrorMessage = true) => {
  const url = signatureParameters.host;
  const formDataItems = {
    key: signatureParameters.objectKey,
    policy: signatureParameters.policy,
    OSSAccessKeyId: signatureParameters.accessKeyId,
    success_action_status: '200',
    signature: signatureParameters.signature,
  };
  const config = {
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      if (onProgress) onProgress(percentCompleted);
      return percentCompleted;
    },
    hideSpinner: true,
    hideErrorMessage,
  };
  if (onCancel) {
    const CancelToken = axios.CancelToken;
    config.cancelToken = new CancelToken((c) => onCancel(c));
  }
  const formData = new FormData();
  Object.keys(formDataItems).map(key => formData.append(key, formDataItems[key]));
  formData.append('file', file);
  const uploadResponse = await request.post(url, formData, config);
  return uploadResponse;
};
const uploadToS3 = async (url, file, onProgress, onCancel) => {
  const config = {
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      if (onProgress) onProgress(percentCompleted);
      return percentCompleted;
    },
    hideSpinner: true,
    headers: {
      'content-disposition': `inline; filename=${file.name}`,
      'content-type': file.type,
    },
  };

  if (onCancel) {
    const controller = new AbortController();
    controller.abort();
  }

  return axios.put(url, file, config);
};

export {
  uploadToOSS,
  uploadToS3,
};
